import createUseContext from "constate";
import React from "react";

import { IUserState, ISchool } from "../../interface";

const initialUserState: IUserState = {
  signedIn: undefined,
  selectedSchool: undefined
};

function useUserState({ initialState = initialUserState } = {}) {
  const [userState, setUserState] = React.useState<IUserState>(
    initialUserState
  );
  const switchSignedIn = (switchTo: boolean): void => {
    switchTo
      ? setUserState({ ...userState, signedIn: true })
      : setUserState({ ...userState, signedIn: false });
  };
  const selectSchool = (selectedSchool: ISchool): void => {
    setUserState({ ...userState, selectedSchool: selectedSchool });
  };
  return { userState, switchSignedIn, selectSchool };
}

const useUserStateContext = createUseContext(useUserState, value => [
  value.userState
]);

export default useUserStateContext;

export const getUrl = (): string => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  } else {
    return "";
  }
};
